export const securityUtils = {
  sanitizeInput(value: string): string {
    return Array.from(value.normalize("NFC"))
      .filter(character => character.charCodeAt(0) >= 32 && character.charCodeAt(0) !== 127 && character !== "<" && character !== ">")
      .join("").trim();
  },
};
